import React from 'react';

import './grid.scss';



const Grid = ({ children }) => {
  return (
      <React.Fragment>
        <div id="als-portvolio-v3">
          <div className="p-v3-global-container p-v3-t-transition-container">
            <div>
              <div className="p-v3-grid">
                { children }
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
  );
}

export default Grid;
